// extracted by mini-css-extract-plugin
export var boxItems = "_8m-1";
export var boxItemsLg = "_8m-2";
export var button = "_8m-7";
export var buttonHoverless = "_8m-9";
export var buttonLg = "_8m-8";
export var filterGroupBox = "_8m-0";
export var icon = "_8m-3";
export var iconSecondary = "_8m-6";
export var iconWrapper = "_8m-4";
export var iconWrapperLg = "_8m-5";
export var truncatedLabel = "_8m-a";